import { CustomerScreen, ProcessStep, type ProcessSessionGatesDto } from '@carvia/ros-client-types';

/** Map agent handover step to the counter iPad screen (mirrors agent route sync). */
export function resolveCustomerScreen(
  step: ProcessStep | null,
  counterId: string | null | undefined,
  gates?: ProcessSessionGatesDto,
): CustomerScreen | undefined {
  if (!counterId) return undefined;
  if (
    gates?.customerSignatureCaptured &&
    gates?.customerContactConfirmed &&
    step === ProcessStep.HANDOVER_CONTRACT
  ) {
    return CustomerScreen.SIGNATURE_DONE;
  }
  if (step === ProcessStep.HANDOVER_CONTRACT && gates?.customerContactConfirmed) {
    return CustomerScreen.CONTRACT_SIGNATURE;
  }
  if (step === ProcessStep.HANDOVER_OVERVIEW) {
    return CustomerScreen.BOOKING_SUMMARY;
  }
  if (step === ProcessStep.HANDOVER_PAYMENT) {
    return CustomerScreen.DEPOSIT_PAYMENT;
  }
  if (step === ProcessStep.HANDOVER_CLIENT_DATA) {
    return CustomerScreen.CONTACT_CONFIRMATION;
  }
  return CustomerScreen.IDLE;
}

export function resolveCounterDisplayScreen(input: {
  agentProcessStep: ProcessStep | null;
  counterId?: string | null;
  customerScreen?: CustomerScreen;
  gates?: ProcessSessionGatesDto;
}): CustomerScreen {
  const fromStep = resolveCustomerScreen(input.agentProcessStep, input.counterId, input.gates);
  if (fromStep !== undefined) {
    return fromStep;
  }
  return input.customerScreen ?? CustomerScreen.IDLE;
}
